import { Routes } from '@angular/router';
import { FirstpageComponent } from "../mainpage/frontpage/firstpage.component"

export const Router:Routes = [
  { path:'', component:FirstpageComponent},
  { path:'servicepage', component:FirstpageComponent,data:{title:'首页'},},
  { path:'servicepage/purchase', loadChildren:"../mainpage/purchase/purchase.module#PurchaseModule"},
  { path:'servicepage/contract',loadChildren:"../mainpage/allcontract/allcontract.module#AllcontractModule"},
  { path:'servicepage/connectus', loadChildren:"../mainpage/connect/connect.module#ConnectModule"},
  { path:'servicepage/firm', loadChildren:"../mainpage/firmes/firmes.module#FirmesModule"},
  { path:'servicepage/statistics', loadChildren:"../mainpage/statistic/statistic.module#StatisticModule"},
  { path:'servicepage/message', loadChildren:"../mainpage/message/message.module#MessageModule"}
];





// WEBPACK FOOTER //
// ./src/router/router.ts